import React, { useState } from "react";
import "./recommended.css";
import Button from "../components/Button";

export default function Recommended({ handleClick }) {
  const [activeBtn, setActiveBtn] = useState("all");
  const handleAddClass = (value) => {
    setActiveBtn(value);
  };
  return (
    <div className="category">
      <div className="categ-brand">
        <h3>Recommended</h3>
        <Button
          handleClick={handleClick}
          handleAddClass={handleAddClass}
          value="all"
          title="All Product"
          activeBtn={activeBtn}
        />
        <Button
          handleClick={handleClick}
          handleAddClass={handleAddClass}
          value="Nike"
          title="Nike"
          activeBtn={activeBtn}
        />
        <Button
          handleClick={handleClick}
          handleAddClass={handleAddClass}
          value="Adidas"
          title="Adidas"
          activeBtn={activeBtn}
        />
        <Button
          handleClick={handleClick}
          handleAddClass={handleAddClass}
          value="Puma"
          title="Puma"
          activeBtn={activeBtn}
        />
        <Button
          handleClick={handleClick}
          handleAddClass={handleAddClass}
          value="Vans"
          title="Vans"
          activeBtn={activeBtn}
        />
      </div>
    </div>
  );
}
